import React from 'react';

export const InventoryContext = React.createContext({
  entityName: '',
  copies: {},
  activePatch: {},
});
export const InventoryProvider = InventoryContext.Provider;
export const InventoryConsumer = InventoryContext.Consumer;
